export function base64ToFile(base64String: string, fileName: string) {
  const byteCharacters = atob(base64String); // Decode Base64 string
  const byteNumbers = new Array(byteCharacters.length);

  for (let index = 0; index < byteCharacters.length; index++) {
    byteNumbers[index] = byteCharacters.charCodeAt(index);
  }

  const byteArray = new Uint8Array(byteNumbers);
  const blob = new Blob([byteArray]);

  const fileType =
    fileName.split('.').pop() === 'png' ? 'image/png' : 'image/jpeg';

  return new File([blob], fileName, { type: fileType });
}
